import { useMemo } from 'react';
import { AccountFlow } from '@shared/api';

export const useAccountFlow = (flows?: AccountFlow[] | null, accountId?: number) => {
  return useMemo(() => {
    if (!flows?.length || !accountId) return undefined;
    return flows.find((flow) => flow.accountId === accountId);
  }, [flows, accountId]);
};
